import BannerContent from './BannerContent';

export default BannerContent;